module.exports = __webpack_public_path__ + "img/son-bf.d95c2b03.jpg";